import { render, staticRenderFns } from "./MAHome_Detail.vue?vue&type=template&id=198dc8b7&scoped=true&"
import script from "./MAHome_Detail.vue?vue&type=script&lang=js&"
export * from "./MAHome_Detail.vue?vue&type=script&lang=js&"
import style0 from "./MAHome_Detail.vue?vue&type=style&index=0&id=198dc8b7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198dc8b7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
